import { useEffect, useState } from "react";
import PortalLayout from "@/pages/portal/PortalLayout";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { Briefcase, ArrowRight, Clock } from "lucide-react";
import { CONSULTATION_URL } from "@/data/constants";

const StageBadge = ({ stage }) => (
  <span className="ft-badge">{stage}</span>
);

const PortalDashboard = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/portal/dashboard").then((r) => setData(r.data)).catch(() => {});
  }, []);

  return (
    <PortalLayout>
      <div className="mb-8">
        <div className="ft-eyebrow mb-2">Client Portal</div>
        <h1 className="text-3xl font-bold tracking-tight">Welcome{data ? `, ${data.user.full_name.split(" ")[0]}` : ""}.</h1>
        <p className="text-[var(--ft-muted)] mt-2">Everything happening across your FLOWTALIS projects, in one place.</p>
      </div>

      <div className="grid md:grid-cols-3 gap-4 mb-8">
        <div className="ft-card">
          <div className="ft-stat-label">Active Projects</div>
          <div className="ft-stat-value mt-2" data-testid="stat-active-projects">{data?.active_projects ?? "—"}</div>
        </div>
        <div className="ft-card">
          <div className="ft-stat-label">Total Projects</div>
          <div className="ft-stat-value mt-2" data-testid="stat-total-projects">{data?.total_projects ?? "—"}</div>
        </div>
        <div className="ft-card">
          <div className="ft-stat-label">Account</div>
          <div className="ft-stat-value mt-2 truncate text-base">{data?.user?.company || "—"}</div>
        </div>
      </div>

      <div className="ft-card">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-lg font-semibold">Recent Projects</h2>
          <Link to="/portal/projects" className="ft-btn-ghost">View all <ArrowRight size={14} /></Link>
        </div>
        {data?.projects?.length ? (
          <div className="space-y-3">
            {data.projects.map((p) => (
              <Link
                key={p.id}
                to={`/portal/projects/${p.id}`}
                data-testid={`portal-project-${p.id}`}
                className="flex items-center gap-4 p-4 rounded-xl border border-[var(--ft-border)] hover:border-[var(--ft-blue)] transition-colors"
              >
                <div className="p-3 rounded-lg" style={{ background: "rgba(11,95,165,0.08)" }}>
                  <Briefcase size={18} style={{ color: "var(--ft-blue)" }} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold truncate">{p.name}</div>
                  <div className="text-sm text-[var(--ft-muted)] flex items-center gap-2 mt-1">
                    <Clock size={12} /> {p.product_category}
                  </div>
                </div>
                <div className="hidden sm:flex flex-col items-end gap-2">
                  <StageBadge stage={p.stage} />
                  <div className="w-32 h-1 bg-[var(--ft-border)] rounded-full overflow-hidden">
                    <div className="h-full" style={{ width: `${p.progress || 0}%`, background: "var(--ft-blue)" }} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-12 text-[var(--ft-muted)]">
            <p>No projects yet.</p>
            <a href={CONSULTATION_URL} target="_blank" rel="noopener noreferrer" className="ft-btn-primary mt-4 inline-flex">Book Consultation</a>
          </div>
        )}
      </div>
    </PortalLayout>
  );
};

export default PortalDashboard;
